import type {
  InputTypeTextProps,
  SchemaOptions,
  ValidationFunc,
} from "~/components/Forms/Fields/Base/InputTypesProps";
import { InputTypeText } from "~/components/Forms/Fields/Base/InputTypeText";
import { createSignal, splitProps } from "solid-js";
import { regex, safeParse, string, pipe } from "valibot";
import ValidationErrors from "./Base/ValidationErrors";

const LABEL = "Téléphone";
const HELP = undefined;
const IS_REQUIRED_BY_DEFAULT = true;
const MAX_LENGTH = 100;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function PhoneSchema(options?: SchemaOptions) {
  return {
    [options?.name ?? "phone"]: pipe(
      string(),
      regex(
        /(0|\+33|0033|00 33)([12345679])([-. ]?[0-9]{2}){4}/,
        `Le ${LABEL.toLowerCase()} doit commencer par +33 ou 0 suivi de 9 chiffres (+33 X XX XX XX XX, 0X XX XX XX XX)`,
      ),
    ),
  };
}

export function Phone(props: InputTypeTextProps) {
  const [local, others] = splitProps(props, ["label", "help", "required"]);
  const [validationErrors, setValidationErrors] = createSignal<string[]>([]);

  const validate: ValidationFunc = (input) => {
    const ret = safeParse(
      PhoneSchema({ name: props.name ?? "phone" })[props.name ?? "phone"],
      input,
    );
    ret.success
      ? setValidationErrors([])
      : setValidationErrors(ret.issues.map((issue) => issue.message));
  };

  return (
    <>
      <div class={`form-item-${props.name}`}>
        <InputTypeText
          label={local.label || LABEL}
          help={local.help || HELP}
          maxLength={MAX_LENGTH}
          validateFn={validate}
          aria-invalid={validationErrors().length > 0}
          aria-errormessage={`err-${props.name}`}
          required={
            local.required !== undefined
              ? local.required
              : IS_REQUIRED_BY_DEFAULT
          }
          {...others}
          type="tel"
        />
        <ValidationErrors errors={validationErrors()} field={props.name} />
      </div>
    </>
  );
}
